import { render, staticRenderFns } from "./project-dialog-task-table.vue?vue&type=template&id=0817dbbe&scoped=true&"
import script from "./project-dialog-task-table.vue?vue&type=script&lang=js&"
export * from "./project-dialog-task-table.vue?vue&type=script&lang=js&"
import style0 from "./project-dialog-task-table.vue?vue&type=style&index=0&id=0817dbbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817dbbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
